import { Card, Grid, Stack, Typography } from "@mui/material";
import React from "react";
import { useTheme } from "@mui/material/styles";
import AboutBg from "../../../assets/images/aboutbg.jpg";
import AboutImage from "../../../assets/images/about.jpg";
import AlignHorizontalCenterIcon from "@mui/icons-material/AlignHorizontalCenter";
import HorizontalRuleIcon from "@mui/icons-material/HorizontalRule";
import Accordion from "@mui/material/Accordion";
import AccordionDetails from "@mui/material/AccordionDetails";
import AccordionSummary from "@mui/material/AccordionSummary";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import zero from "../../../assets/images/0.png";
import one from "../../../assets/images/1.png";
import two from "../../../assets/images/2.png";
import three from "../../../assets/images/3.png";
import aim from "../../../assets/images/aim.jpg";
import AnimatedNumber from "animated-number-react";
import Served from "../../../assets/images/served.jpg";
import Registered from "../../../assets/images/registered.jpg";
import Placed from "../../../assets/images/placed.jpg";

const About = () => {
  const formatValue = (value) => `${Number(value).toFixed(0)}+`;
  const theme = useTheme();
  return (
    <>
      <Grid container direction="column">
        <Grid item sm={12} sx={{ display: { sm: "block", xs: "none" } }}>
          <Grid
            container
            spacing={3}
            direction="row"
            justifyContent="center"
            alignItems="center"
            sx={{ padding: 4 }}
          >
            <Grid item sm={6} xs={12}>
              <Typography color="primary" sx={{ mb: 2 }} variant="h2">
                About Us
              </Typography>
              <Typography sx={{ mb: 1 }} variant="body1">
                Optima jobs is fastest growing HR firm that provides total HR
                solutions, which includes Executive Search, HR Services, Legal
                Compliance, Employee Assessment & Trainings. Our mission is to
                provide total HR Solutions with perfection, dedication &
                professionalism to the clients willing to grow.
              </Typography>
              <Typography sx={{ mb: 1 }} variant="body1">
                Optima Jobs is established in 5th August 2017, we have expertise
                in placing candidates in every sector. With the team of young &
                qualified professionals we cater the various requirements of the
                companies effectively & successfully. We are connected with our
                clients on various platform and we are inclined to our core
                values to make our bond stronger.
              </Typography>
            </Grid>
            <Grid item sm={6} xs={12}>
              <img src={AboutImage} alt="about-cartoon" width="100%" />
            </Grid>
          </Grid>
        </Grid>
        <Grid
          item
          sm={12}
          xs={12}
          sx={{ display: { sm: "none", xs: "block" } }}
        >
          <Grid
            container
            spacing={3}
            direction="row"
            justifyContent="center"
            alignItems="center"
            sx={{ padding: 4 }}
          >
            <Grid align="center" item sm={6} xs={12}>
              <img src={AboutImage} alt="about-cartoon" width="100%" />
            </Grid>
            <Grid align="center" item sm={6} xs={12}>
              <Typography color="primary" sx={{ mb: 2 }} variant="h2">
                About Us
              </Typography>
              <Typography align="left" sx={{ mb: 1 }} variant="body1">
                Optima jobs is fastest growing HR firm that provides total HR
                solutions, which includes Executive Search, HR Services, Legal
                Compliance, Employee Assessment & Trainings. Our mission is to
                provide total HR Solutions with perfection, dedication &
                professionalism to the clients willing to grow.
              </Typography>
              <Typography align="left" sx={{ mb: 1 }} variant="body1">
                Optima Jobs is established in 5th August 2017, we have expertise
                in placing candidates in every sector. With the team of young &
                qualified professionals we cater the various requirements of the
                companies effectively & successfully. We are connected with our
                clients on various platform and we are inclined to our core
                values to make our bond stronger.
              </Typography>
            </Grid>
          </Grid>
        </Grid>
        {/* <---------------------------------------------------------------Values---------------------------------------------------------------> */}
        <Grid
          item
          sm={12}
          xs={12}
          sx={{ backgroundColor: theme.palette.grey[200] }}
        >
          <Grid
            container
            spacing={4}
            direction="row"
            justifyContent="center"
            alignItems="center"
            sx={{ padding: 4 }}
          >
            <Grid align="center" item sm={12} xs={12}>
              <Typography color="primary" variant="h2">
                Our Core Values
              </Typography>
            </Grid>
            <Grid align="center" item sm={4} xs={12}>
              <Card elevation={3} sx={{ padding: 6 }}>
                <img src={zero} alt="zero" />
                <img src={one} alt="one" />
                <Typography color={theme.palette.secondary.main} variant="h3">
                  Perfection
                </Typography>
              </Card>
            </Grid>
            <Grid align="center" item sm={4} xs={12}>
              <Card elevation={3} sx={{ padding: 6 }}>
                <img src={zero} alt="zero" />
                <img src={two} alt="two" />
                <Typography color={theme.palette.secondary.main} variant="h3">
                  Dedication
                </Typography>
              </Card>
            </Grid>
            <Grid align="center" item sm={4} xs={12}>
              <Card elevation={3} sx={{ padding: 6 }}>
                <img src={zero} alt="zero" />
                <img src={three} alt="three" />
                <Typography color={theme.palette.secondary.main} variant="h3">
                  Professionalism
                </Typography>
              </Card>
            </Grid>
          </Grid>
        </Grid>

        {/* <---------------------------------------------------------------Vision---------------------------------------------------------------> */}
        {/* <Grid item sm={12} sx={{ display: { sm: "block", xs: "none" } }}>
          <Grid
            container
            spacing={4}
            direction="row"
            justifyContent="center"
            alignItems="center"
            sx={{ padding: 4 }}
          >
            <Grid item sm={6}>
              <img src={aim} alt="aim" width="80%" />
            </Grid>
            <Grid item sm={6}>
              <Typography color="primary" variant="h2" sx={{ mb: 1 }}>
                Our Vision
              </Typography>
              <Typography variant="body1" sx={{ mb: 3 }}>
                Our Vision is to become India’s leading HR firm by providing
                utmost services to our clients.
              </Typography>
              <Typography color="primary" variant="h2" sx={{ mb: 1 }}>
                Our Mission
              </Typography>
              <Typography variant="body1">
                Our mission is to provide total HR Solutions with perfection,
                dedication & professionalism to the clients willing to grow.
              </Typography>
            </Grid>
          </Grid>
        </Grid> */}
        {/* <Grid
          item
          sm={12}
          xs={12}
          sx={{ display: { sm: "none", xs: "block" } }}
        >
          <Grid
            container
            spacing={4}
            direction="row"
            justifyContent="center"
            alignItems="center"
            sx={{ padding: 4 }}
          >
            <Grid align="center" item sm={6} xs={12}>
              <img src={aim} alt="aim" width="80%" />
            </Grid>
            <Grid align="center" item sm={6} xs={12}>
              <Typography color="primary" variant="h2" sx={{ mb: 1 }}>
                Our Vision
              </Typography>
              <Typography variant="body1" sx={{ mb: 3 }}>
                Our Vision is to become India’s leading HR firm by providing
                utmost services to our clients.
              </Typography>
              <Typography color="primary" variant="h2" sx={{ mb: 1 }}>
                Our Mission
              </Typography>
              <Typography variant="body1">
                Our mission is to provide total HR Solutions with perfection,
                dedication & professionalism to the clients willing to grow.
              </Typography>
            </Grid>
          </Grid>
        </Grid> */}
        {/* <---------------------------------------------------------------Stats---------------------------------------------------------------> */}
        <Grid
          item
          sm={12}
          xs={12}
          sx={{ backgroundColor: theme.palette.primary.light }}
        >
          <Grid
            container
            spacing={4}
            direction="row"
            justifyContent="center"
            alignItems="center"
            sx={{ padding: 4 }}
          >
            <Grid align="center" item sm={4} xs={12}>
              <Card elevation={3} sx={{ padding: 2 }}>
                <img src={Served} alt="served" width="40%" />
                <Typography color="secondary" variant="h2">
                  <AnimatedNumber
                    value="250"
                    formatValue={formatValue}
                    duration="8000"
                  />
                </Typography>
                <HorizontalRuleIcon fontSize="large" color="primary" />
                <Typography variant="h5">Clients Served</Typography>
              </Card>
            </Grid>
            <Grid align="center" item sm={4} xs={12}>
              <Card elevation={3} sx={{ padding: 2 }}>
                <img src={Registered} alt="served" width="38%" />
                <Typography color="secondary" variant="h2">
                  <AnimatedNumber
                    value="3500"
                    formatValue={formatValue}
                    duration="8000"
                  />
                </Typography>
                <HorizontalRuleIcon fontSize="large" color="primary" />
                <Typography variant="h5">Candidates Registered</Typography>
              </Card>
            </Grid>
            <Grid align="center" item sm={4} xs={12}>
              <Card elevation={3} sx={{ padding: 2 }}>
                <img src={Placed} alt="served" width="70%" />
                <Typography color="secondary" variant="h2">
                  <AnimatedNumber
                    value="1000"
                    formatValue={formatValue}
                    duration="8000"
                  />
                </Typography>
                <HorizontalRuleIcon fontSize="large" color="primary" />
                <Typography variant="h5">Candidates Placed</Typography>
              </Card>
            </Grid>
          </Grid>
        </Grid>
        {/* <---------------------------------------------------------------FAQ---------------------------------------------------------------> */}
        <Grid item sm={12} xs={12}>
          <Grid
            container
            // justifyContent="center"
            // alignItems="center"
            // spacing={3}
            // maxWidth="md"
            spacing={4}
            direction="column"
            justifyContent="center"
            alignItems="center"
            sx={{ padding: 4, mt: 2 }}
          >
            <Grid item sm={12} xs={12}>
              <Typography variant="h2" color="primary" textAlign="center">
                FREQUENTLY ASKED QUESTIONS
              </Typography>
            </Grid>

            <Grid item xs={12}>
              <Accordion sx={{ background: "#fafafa" }}>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1a-content"
                  id="panel1a-header"
                >
                  <Typography variant="h6">
                    How much do you charge to the candidates?
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography>
                    No we do not charge to candidates. Its free for candidates.
                  </Typography>
                </AccordionDetails>
              </Accordion>
              <Accordion sx={{ background: "#fafafa" }}>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1a-content"
                  id="panel1a-header"
                >
                  <Typography variant="h6">
                    How much do you charge to the companies?
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography>
                    If any company wants to enquire for this please follow the
                    below link.
                  </Typography>
                </AccordionDetails>
              </Accordion>
              <Accordion
                sx={{
                  background: "#fafafa",
                }}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1a-content"
                  id="panel1a-header"
                >
                  <Typography variant="h6">
                    Do you provide Government Jobs?
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography>
                    No we do not provide Government jobs. We only provide Jobs
                    in Private companies.
                  </Typography>
                </AccordionDetails>
              </Accordion>
              <Accordion sx={{ background: "#fafafa" }}>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1a-content"
                  id="panel1a-header"
                >
                  <Typography variant="h6">
                    How is your recruitment process?
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography>
                    You just need to fill our form and upload your resume. You
                    will be contacted from our office for the interview calls.
                  </Typography>
                </AccordionDetails>
              </Accordion>
              <Accordion sx={{ background: "#fafafa" }}>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1a-content"
                  id="panel1a-header"
                >
                  <Typography variant="h6">
                    Do you provide trainings?
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography>
                    Yes we do provide Trainings and Trainers for candidates as
                    well as to companies.
                  </Typography>
                </AccordionDetails>
              </Accordion>
              <Accordion sx={{ background: "#fafafa" }}>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1a-content"
                  id="panel1a-header"
                >
                  <Typography variant="h6">
                    In which locations you provide jobs?
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography>
                    We provide jobs in all over India and preferably in West
                    Maharashtra region ( Kolhapur , Sangli, Karad, Satara, Goa,
                    Belgaum)
                  </Typography>
                </AccordionDetails>
              </Accordion>
              <Accordion sx={{ background: "#fafafa" }}>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1a-content"
                  id="panel1a-header"
                >
                  <Typography variant="h6">
                    Do you provide support for Resume writing?
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography>
                    Yes we do assist you in Resume writing.
                  </Typography>
                </AccordionDetails>
              </Accordion>
              <Accordion sx={{ background: "#fafafa" }}>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1a-content"
                  id="panel1a-header"
                >
                  <Typography variant="h6">
                    Do you provide jobs for freshers?
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography>
                    Yes we provide Jobs for Freshers as well as Experienced
                    candidates.
                  </Typography>
                </AccordionDetails>
              </Accordion>
              <Accordion sx={{ background: "#fafafa" }}>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1a-content"
                  id="panel1a-header"
                >
                  <Typography variant="h6">
                    Do you provide Work from home jobs?
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography>
                    Yes we provide opportunities for all type of Jobs
                  </Typography>
                </AccordionDetails>
              </Accordion>
              <Accordion sx={{ background: "#fafafa" }}>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1a-content"
                  id="panel1a-header"
                >
                  <Typography variant="h6">
                    Do you provide part time jobs?
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography>
                    Yes as per requirements from companies we provide these kind
                    of Jobs.
                  </Typography>
                </AccordionDetails>
              </Accordion>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
};

export default About;
